var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A3D13174-37F4-4244-A33F-62BF580C38B7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logins---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Customer-Portal---Desktop---Logins---V2",
    transform: "translate(-1251.000000, -986.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bars/Footer",
    transform: "translate(0.000000, 960.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social-Media",
    transform: "translate(1191.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Youtube",
    transform: "translate(52.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyphs/Social-Media/Linkedin",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_youtube",
    transform: "translate(0.000000, 2.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6703125,1.7758789 C15.4859375,1.0904297 14.9455078,0.55009765 14.2601562,0.36552735 C13.0081055,0.022949225 7.9998047,0.022949225 7.9998047,0.022949225 C7.9998047,0.022949225 2.99169922,0.022949225 1.73964845,0.35253905 C1.06748047,0.53691405 0.5138672,1.09052735 0.3294922,1.7758789 C0,3.02783202 0,5.62421875 0,5.62421875 C0,5.62421875 0,8.2336914 0.3294922,9.4725586 C0.5140625,10.1579101 1.05429687,10.6982422 1.7397461,10.8828125 C3.0048828,11.2254883 8,11.2254883 8,11.2254883 C8,11.2254883 13.0081055,11.2254883 14.2601562,10.8958985 C14.9456055,10.7114258 15.4859375,10.1710937 15.6705078,9.4857422 C15.9999696,8.2336914 15.9999696,5.63740235 15.9999696,5.63740235 C15.9999696,5.63740235 16.0130859,3.02783203 15.6703125,1.7758789 L15.6703125,1.7758789 Z M6.40527345,8.02285155 L6.40527345,3.22558595 L10.5699219,5.62421875 L6.40527345,8.02285155 Z",
    id: "Shape"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon_youtube.4c26205b8644efa62d1d0597c2e5144f.svg";
export { ForwardRef as ReactComponent };